import { getRuleErrorMessage } from "@/utils/formHelper";

import { qrListPickerValidations, qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrLinksValidation = (data, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "title",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("title", "maxLength", data),
        },
      },
    },
    {
      name: "description",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("description", "maxLength", data),
        },
      },
    },
    ...qrListPickerValidations("social_invalid", t),
  ];
};
